module.exports = __webpack_public_path__ + "img/banner.32d702f5.png";